export default __webpack_public_path__ + "static/media/scheduleCalendar.987bab7c.svg";